import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { meQueryOptions } from "@/features/auth/api/auth.queries";
import { SettingsPage } from "@/features/settings/SettingsPage";

// Guarded by the _app layout — applicants are already redirected to /pending.
export const Route = createFileRoute("/_app/settings")({
  component: SettingsRoute,
});

function SettingsRoute() {
  const { data: me } = useSuspenseQuery(meQueryOptions);
  return <SettingsPage isAdmin={me.permissionRole === "admin"} />;
}
